/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `m3/s` - m3/s
 * @export
 */
export const LateralUnitsEnum = {
  M3_S: "m3/s",
} as const;
export type LateralUnitsEnum = (typeof LateralUnitsEnum)[keyof typeof LateralUnitsEnum];

export function instanceOfLateralUnitsEnum(value: any): boolean {
  for (const key in LateralUnitsEnum) {
    if (Object.prototype.hasOwnProperty.call(LateralUnitsEnum, key)) {
      if (LateralUnitsEnum[key as keyof typeof LateralUnitsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LateralUnitsEnumFromJSON(json: any): LateralUnitsEnum {
  return LateralUnitsEnumFromJSONTyped(json, false);
}

export function LateralUnitsEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LateralUnitsEnum {
  return json as LateralUnitsEnum;
}

export function LateralUnitsEnumToJSON(value?: LateralUnitsEnum | null): any {
  return value as any;
}

export function LateralUnitsEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): LateralUnitsEnum {
  return value as LateralUnitsEnum;
}
